module.exports = __webpack_public_path__ + "media/images/logo/gigbase-sol_logo-a216704c3e6d89e851c4454853e0d813.svg";